module.exports = __webpack_public_path__ + "media/doorclose03.f7bde9d5.mp3";